import { GuestStart } from '../../api/guest-chat'

export type GuestDraft = {
  details: Omit<GuestStart, 'message' | 'clientId' | 'captchaKey' | 'captchaValue'>
  text: string
  id: string
}

const key = 'guest-chat-first-message'

export const readGuestDraft = (): GuestDraft | undefined => {
  try {
    const draft = JSON.parse(sessionStorage.getItem(key) || 'null')
    if (
      draft &&
      typeof draft.text === 'string' &&
      draft.text.trim() &&
      draft.text.length <= 1000 &&
      typeof draft.id === 'string' &&
      typeof draft.details?.name === 'string' &&
      Number.isInteger(draft.details.competence) &&
      Number.isInteger(draft.details.expert) &&
      draft.details.consent === true
    ) {
      return {
        text: draft.text,
        id: draft.id,
        details: {
          name: draft.details.name,
          competence: draft.details.competence,
          expert: draft.details.expert,
          consent: true,
        },
      }
    }
  } catch {
    // Unavailable storage or a malformed draft must not prevent using the chat.
  }
}

export const saveGuestDraft = (draft?: GuestDraft) => {
  try {
    if (draft) sessionStorage.setItem(key, JSON.stringify(draft))
    else sessionStorage.removeItem(key)
  } catch {
    // The current page still keeps the message in React state.
  }
}
